module.exports = __webpack_public_path__ + "static/img/WisdomSiteKan.bbdba7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteKan.png
// module id = dXcl
// module chunks = 12